import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 320;

const style = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },
  columns: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: 20,
  },
  flexRow: {
    display: "flex",
    paddingLeft: "20px",
    paddingRight: "20px",
    justifyContent: "space-between",
    alignItems: "baseline",
    width: "100%",
  },
  flexRowSchedule: {
    display: "flex",
    paddingLeft: "20px",
    paddingRight: "20px",
    justifyContent: "space-between",
    width: "100%",
  },
  fieldsEditor: {
    width: "400px",
    marginTop: "80px",
  },
  paddtop: {
    display: "flex",
    wrap: "yes",
    width: "200ppx",
    marginTop: "100px",
  },
  paddfields: {
    Width: "48%",
  },
  image: {
    width: "150px",
    marginLeft: "10px",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#222",
  },
  errorColor: {
    color: "#9d9d99",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#222",
  },
  menuButton: {
    marginRight: 36,
    color: "#9d9d9d",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    backgroundColor: "#222",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
    // New Code. 
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(0) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.up('md')]: {
      marginLeft: '73px',
    },
  },
  //business
  appBarForm: {
    position: "relative",
    backgroundColor: "#222",
  },
  rootBusiness: {
    display: "flex",
    flexWrap: "wrap",
  },
  textFieldBusiness: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
  },
  schedule: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  scheduleItem: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 20,
    marginLeft: 10,
    marginRight: 10,
  },
  timeFieldSchedule: {
    width: "40%",
    margin: 5,
  },
  listAlerts: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    width: "30%",
  },
  titlePaper: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    fontSize: "20px",
    alignItems: "center",
    justifyContent: "center",
  },
  rowList: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  marker: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "1px",
    height: "1px",
    userSelect: "none",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
  },
  icon: {
    position: "absolute",
    width: "45px",
    left: "-22.5px",
    top: "-48.5px",
  },
  profilePhoto: {
    position: "absolute",
    width: "29px",
    left: "-14.5px",
    top: "-40px",
  },
  inputText: {
    width: "50%",
    padding: "5px",
  },
  column: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    justifyContent: "center",
  },
  box: {
    display: "flex",
    flexFlow: "column",
    height: "100%"
  },
  menuTextItem: {
    maxHeight: '24px',
    overflow: 'hidden', 
    textOverflow: 'ellipsis' 
  },
  imgListItem: {
    height: '100%',
    width: '100%',
  },
  imgListItemSelectable: {
    borderRadius: '2px 2px 0px 0px',
    maxWidth: '100%',
    height: '100%',
    objectFit: 'cover',
    '&:hover': {
      'boxShadow': '0 0 2px 2px rgba(0, 140, 186, 0.75)',
      'cursor': 'pointer'
    }
  },
  selectable: {
    '&:hover': {
      'cursor': 'pointer'
    }
  },
  ellipseableText: {
   overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkit-box-orient': 'vertical',
}

}));

export default style;
